import { httpsCallable } from 'firebase/functions';
import { functions } from '../config/firebase';

const publishCallable = httpsCallable(functions, 'publishFundPeriodInvestorReport');
const getReportCallable = httpsCallable(functions, 'getPublishedFundPeriodReportForInvestor');

/**
 * @param {{ periodKey: string, publish: boolean, investorReportComment?: string }} params
 */
export async function publishFundPeriodInvestorReport(params) {
  const res = await publishCallable(params);
  return res?.data;
}

/**
 * @param {{ fundInvestorId: string, periodKey: string }} params
 */
export async function getPublishedFundPeriodReportForInvestor(params) {
  const res = await getReportCallable(params);
  return res?.data;
}
